import { generateClient } from 'aws-amplify/api';
import { createOperationEvent } from '../../graphql/mutations';

export const DEFAULT_LOCATION_ID = 'DGP-ALBANY';

export const EVENT_TYPES = {
  ASSIGNED: 'ASSIGNED',
  STARTED: 'STARTED',
  PAUSED: 'PAUSED',
  RESUMED: 'RESUMED',
  WAITING_PARTS: 'WAITING_PARTS',
  WAITING_AUTHORIZATION: 'WAITING_AUTHORIZATION',
  HOLD: 'HOLD',                    // road call paused with a reason attached
  TRAVELING: 'TRAVELING',
  ARRIVED: 'ARRIVED',
  DIAGNOSING: 'DIAGNOSING',
  REPAIRING: 'REPAIRING',
  ROAD_TEST: 'ROAD_TEST',
  QC: 'QC',
  COMPLETED: 'COMPLETED',
  CUSTOMER_UPDATED: 'CUSTOMER_UPDATED',
  PHOTO_ADDED: 'PHOTO_ADDED',
  NOTE_ADDED: 'NOTE_ADDED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  VOIDED: 'VOIDED',
  CALL_CREATED: 'CALL_CREATED',
  CUSTOMER_SIGNED: 'CUSTOMER_SIGNED',
  CANCELLED: 'CANCELLED',
};

const client = generateClient();

export function getLocationId(record) {
  return record?.locationId || record?.shopId || DEFAULT_LOCATION_ID;
}

export function nowSeconds() {
  return Math.floor(Date.now() / 1000);
}

export function buildTruckEventInput(truck, eventType, overrides = {}) {
  const timestamp = overrides.timestamp || nowSeconds();
  const metadata = {
    repairOrder: truck?.repairOrder || null,
    companyName: truck?.companyName || null,
    truckNumber: truck?.truckNumber || null,
    source: 'web',
    ...(overrides.metadata || {}),
  };

  return {
    eventType,
    timestamp,
    locationId: overrides.locationId || getLocationId(truck),
    assetId: overrides.assetId || truck?.id || null,
    workOrderId: overrides.workOrderId || truck?.id || null,
    technicianId: overrides.technicianId || null,
    userId: overrides.userId || null,
    previousStatus: overrides.previousStatus ?? null,
    newStatus: overrides.newStatus ?? null,
    note: overrides.note || null,
    relatedPhotoIds: overrides.relatedPhotoIds || [],
    metadata: JSON.stringify(metadata),
  };
}

export async function recordOperationEvent(input) {
  try {
    await client.graphql({
      query: createOperationEvent,
      variables: { input },
    });
    return true;
  } catch (err) {
    console.warn('[OperationEvent] create failed:', err.message);
    return false;
  }
}

export function recordTruckEvent(truck, eventType, overrides = {}) {
  return recordOperationEvent(buildTruckEventInput(truck, eventType, overrides));
}
